module.exports = __webpack_public_path__ + "media/application/images/icons/arrow-left-a6700141f12f6d72b205436592ae12c7.svg";